import { connect } from 'react-redux';

import { getServicesInAppointment } from 'selectors/services';

import { AppointmentInfo as BasicAppointmentInfo } from 'components/BookingSteps/AppointmentInfo/AppointmentInfo';

import { TAppointment } from 'types/appointment';
import { TService } from 'types/service';

type AppointmentInfoProps = {
  isMultiUser: boolean;
  appointment: TAppointment;
  selectedServices: TService[];
};

const AppointmentInfo = (props: AppointmentInfoProps) => {
  const { isMultiUser, appointment, selectedServices = [] } = props;

  const { date, time, start_time, professional } = appointment;

  const dateValue = date || time || start_time;
  const timeValue = time || start_time;

  const servicesNames = selectedServices?.map((service) => service.name);

  const appointments = [
    {
      date: dateValue,
      isMultiUser: isMultiUser,
      professionalName: professional?.full_name,
      servicesNames: servicesNames,
      time: timeValue,
    },
  ];

  return <BasicAppointmentInfo appointments={appointments} />;
};

export const AppointmentInfoBox = AppointmentInfo;

export default connect((state: any) => ({
  appointment: state.appointment,
  isMultiUser: state.publicUser.multi_user,
  selectedServices: getServicesInAppointment(state),
}))(AppointmentInfo);
